/** Available contract statuses */
export enum ContractStatusEnum {
  /** Active contract */
  ACTIVE = 'ACTIVE',
  /** Achived contract */
  ARCHIVED = 'ARCHIVED'
}
